import type { BasicListOption } from '../../GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { RadioTextFilterOperation } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { URL_PLACEHOLDERS } from '../../GenericConstants/GenericOperationPlaceholders';
import { SubFilterErrorKind } from '../ErrorFilterType';

export const SUB_FILTER_KIND_OPTION_LIST: BasicListOption<SubFilterErrorKind>[] = [
  { value: SubFilterErrorKind.TEXT, label: 'error text' },
  { value: SubFilterErrorKind.PAGE_PATH, label: 'page URL' },
];

const TEXT_PLACEHOLDERS = {
  [RadioTextFilterOperation.CONTAINS]: 'e.g. Unknown Error',
  [RadioTextFilterOperation.IS]: 'e.g. Unknown Error',
  [RadioTextFilterOperation.IS_NOT]: 'e.g. Unknown Error',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. Unknown Error',
};

export const PLACEHOLDER_BY_TYPE = {
  [SubFilterErrorKind.PAGE_PATH]: URL_PLACEHOLDERS,
  [SubFilterErrorKind.TEXT]: TEXT_PLACEHOLDERS,
};

export const COLUMN_ONE_WIDTH = 240;

export const COLUMN_TWO_WIDTH = 164;
